import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmServiceService {

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private snackbar: MatSnackBar,
  ) { }
  openServiceDialog(componentName: any, height: any, width: any, maxWidth: any, dataModel: any, position: any = { right: '0px', top: '0px' }) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth: maxWidth,
      data: dataModel,
      disableClose: false,
      position: position,
    });
  }
  getFieldsShowInForm(businessId: any, formName: any) {
    return this.http.get(
      environment.baseUrl + `crm/fields?businessId=${businessId}&status=true&showInForm=ENQUIRY&isPagination=false&fieldCategory=${formName}`
    )
  }
  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }
}
